import {useDispatch, useSelector} from "react-redux";
import InputComponent from "../../../components/input.component";
import React from "react";
import {cloneDeep} from "lodash";
import {setAvoskinTrailRunRaceCategoryDetail} from "../../../reducers/avoksin-trail-run.reducer";

const Item = ({fieldList, index}) => {
    const dispatch = useDispatch()
    const {raceCategoryDetail, avoskinTrailRunErrorMessage} = useSelector(state => state.avoskinTrailRunReducer)

    const onChangeInput = (key, value) => {
        const copyItemList = cloneDeep(raceCategoryDetail.facilities)
        copyItemList[index][key] = value
        dispatch(setAvoskinTrailRunRaceCategoryDetail({facilities: copyItemList}))
    }

    return (
        <div className={"grid grid-cols-2 gap-x-16 gap-y-4"}>
            {fieldList.map((item, i) => (
                <InputComponent key={i} item={item} data={raceCategoryDetail?.facilities?.[index]?.[item.key]} error={avoskinTrailRunErrorMessage[`facilities[${index}]`] ?? {}} onChange={onChangeInput} onChangeInput={onChangeInput}/>
            ))}
        </div>
    )
}

export default Item
